import { useMemo } from 'react';

import { UseOptionsQueryParams, UseOptionsQueryReturnType } from '@/components/FilterNew/types';
import useStatuses from '@/modules/tasks/views/TaskStasusesManager/hooks/useStatuses';

import { getEntityFilterGroups } from '../../../utils';
import { getTaskStatusFilterOption } from '../utils';

const useTaskStatusOptionsQuery = ({
  searchText,
}: UseOptionsQueryParams): UseOptionsQueryReturnType => {
  const {
    isFetching,
    error,
    statuses: initialStatuses,
  } = useStatuses({ excludeEntityStatuses: true });

  const statuses = useMemo(() => {
    if (!searchText) {
      return initialStatuses;
    }

    return initialStatuses.filter((status) =>
      status.name.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [searchText, initialStatuses]);

  const groups = useMemo(
    () => getEntityFilterGroups(statuses, getTaskStatusFilterOption),
    [statuses],
  );

  return { error, groups, fetching: isFetching };
};

export default useTaskStatusOptionsQuery;
